export const styles = {
  container: (theme) => ({
    bgcolor: "#F8F8F8",
  }),
};
